<template>
	<div>
    <pt-form-item label="是否合格:" labelWidth="90px" :required="true">
        <el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否合格">
					<el-radio label="QUALIFIED">合格</el-radio>
					<el-radio label="NOT_QUALIFIED_WAIT_FUTURE_ACTION">不合格</el-radio>
				</el-radio-group>
    </pt-form-item>
    <pt-form-item label="原因:" labelWidth="90px" v-if="form.result == 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'" :required="true">
        <el-input name="reason" data-vv-as="原因" v-validate="'required'" type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" v-model="form.reason" class="texta" :placeholder="form.result == 'QUALIFIED' ? '选填' : '请填写原因'"></el-input>
    </pt-form-item>
    <pt-form-item label="生产条码号:" labelWidth="90px" :required="true" v-else>
        <el-input v-model="form.labCode" name="labCode" v-validate="'required'" data-vv-as="生产条码号"></el-input>
    </pt-form-item>
	</div>
</template>

<script>
import { validate } from 'utils/validate'
import { next } from '../status.js'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  data () {
    return {
      title: '样本接收',
      form: {
        result: 'QUALIFIED',
        reason: '',
        expressNum: ''
      },
      pass: false,
      reasonObj: {
        have: false,
        reasons: []
      }
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    next () {
      let data = {
        orderIds: [this.order.id],
        action: this.status }
      if (this.form.result === 'NOT_QUALIFIED_WAIT_FUTURE_ACTION') {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          reason: this.form.reason
        }
      } else {
        data.labCodes = [{
          orderId: this.order.id,
          labCode: this.form.labCode
        }]
        data.orderStatusDetail = {
          orderStatusResult: this.form.result
        }
      }

      return next.call(this, data)
    }
  },
  created () {

  }

}
</script>

<style lang="less">

</style>
